import { PageHeader } from "@/components/dashboard/page-header";
import { SearchList } from "@/components/dashboard/search-list";
import { ErrorState } from "@/components/dashboard/state";
import { clientApi } from "@/lib/client-api";
import { useQuery } from "@tanstack/react-query";

export function VpDirectorPage() {
  const {
    data = [],
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["client", "searches", "vp_director"],
    queryFn: () => clientApi.searches("vp_director"),
  });

  return (
    <div className="animate-fade-up space-y-8">
      <PageHeader title="VP / Director" description="Senior leadership mandates below the C-suite." />
      {isError ? (
        <ErrorState onRetry={() => refetch()}>Couldn't load these roles.</ErrorState>
      ) : (
        <SearchList rows={data} loading={isLoading} />
      )}
    </div>
  );
}
